import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('aercaribe_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          const response = await axios.post(`${API}/auth/check-token`, { token });
          if (response.data.Error) {
            logout();
          } else {
            const storedUser = localStorage.getItem('aercaribe_user');
            if (storedUser) {
              setUser(JSON.parse(storedUser));
            }
          }
        } catch (error) {
          console.error('Token verification failed:', error);
          logout();
        }
      }
      setLoading(false);
    };

    verifyToken();
  }, [token]);

  const login = async (userId, password) => {
    try {
      const response = await axios.post(`${API}/auth/login`, { userId, password });
      
      if (response.data.Error) {
        return { success: false, error: response.data.MsgError || 'Login failed' };
      }

      const { Token, Nombre } = response.data;
      localStorage.setItem('aercaribe_token', Token);
      localStorage.setItem('aercaribe_user', JSON.stringify({ name: Nombre, userId }));
      setToken(Token);
      setUser({ name: Nombre, userId });
      
      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: 'Authentication service unavailable' };
    }
  };

  const logout = () => {
    localStorage.removeItem('aercaribe_token');
    localStorage.removeItem('aercaribe_user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
